import * as React from "react";
import type { SVGProps } from "react";
const SvgAirplaneFlexible = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#airplane-flexible_svg__a)">
      <g fill="currentColor" clipPath="url(#airplane-flexible_svg__b)">
        <path d="M16.02 6.96c.51-.38 1.26-.28 1.66.23s.31 1.23-.2 1.61l-2.21 1.64c-.19.14-.3.35-.32.57l-.46 5.5c-.08 1-1.57 1.02-1.72.02l-.59-3.8-1.6 1.19a.34.34 0 0 0-.13.3l.19 1.89c.06.65-.78.96-1.19.44L6.2 12.43c-.41-.52.12-1.22.74-1l1.84.67c.11.04.24.02.33-.05l1.61-1.18-3.63-1.54c-.95-.4-.55-1.79.47-1.61l5.59 1.01c.23.04.47-.01.66-.15l2.21-1.64z" />
        <path d="M12.29 24C5.57 24 .17 18.74 0 12.03c-.01-.55.42-1.01.97-1.03.53.02 1.01.42 1.03.97C2.14 17.5 6.75 22 12.29 22c2.84 0 5.48-1.13 7.45-3.19a.996.996 0 1 1 1.44 1.38c-2.34 2.45-5.5 3.81-8.89 3.81" />
        <path d="M21 24c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1" />
        <path d="M21 20h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1M22.99 13c-.54 0-.99-.43-1-.97A10.234 10.234 0 0 0 11.7 2C8.86 2 6.22 3.13 4.26 5.19c-.38.4-1.01.42-1.41.03a.996.996 0 0 1-.03-1.41C5.16 1.35 8.31 0 11.71 0 18.43 0 23.83 5.26 24 11.97c.01.55-.42 1.01-.97 1.03h-.04" />
        <path d="M3 6c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1" />
        <path d="M7 6H3c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1" />
      </g>
    </g>
    <defs>
      <clipPath id="airplane-flexible_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
      <clipPath id="airplane-flexible_svg__b">
        <path fill="#fff" d="M0 0h23.99v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAirplaneFlexible;
